import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { RealTimeMinuteService } from './../minutes/service/real-time-minute.service';
import {
  ClientMinuteRequestDTO,
  CompanyDebtorMinuteRequestResolutionDTO,
  FactoringOperationDTO,
  FilterMinutes,
  InvoiceOperationMinuteDTO,
  MinuteRequestDetailRealTimeDTO,
  MinuteRequestResolutionDTO,
  MinuteRequestSnapshotDTO,
  OwnersMinuteRequest,
} from './interface/minute-detail';
import {
  IconDefinition,
  faCheckCircle,
  faCircleXmark,
  faFolderClosed,
  faPen,
  faBullhorn
} from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MinuteRequestService } from './service/minute-request.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { MinuteRequestKpiDTO } from './interface/minute-request-kpis.interface';
import { ChangeMinuteRequestLineModalComponent } from '../components/change-minute-request-line-modal/change-minute-request-line-modal.component';
import {
  ApproveCompaniesDebtorsRequestDTO,
  ChangeMinuteRequestLineDTO,
} from './interface/minute-request.interface';
import { filter, finalize, switchMap } from 'rxjs';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterMinuteService } from './service/filter-minute.service';
import { FormularioFacturaFormulaComponent } from '../../modals/formulario-factura-formula/formulario-factura-formula.component';
import { DetalleCmfComponent } from '../../components/information/detalle-cmf/detalle-cmf.component';
import { DetalleTgrComponent } from '../../components/information/detalle-tgr/detalle-tgr.component';
import { DetalleIngeAdmComponent } from '../../components/information/detalle-inge-adm/detalle-inge-adm.component';
import { DetalleFogapeComponent } from '../../components/information/detalle-fogape/detalle-fogape.component';
import { TgrServiceService } from '../../service/tgr-service.service';
import { ModificarDescripcionComponent } from '../../modals/modificar-descripcion/modificar-descripcion.component';
import { LegacyScoring } from '../../interface/legacy-scoring';
import { ScoringIngeService } from '../../service/scoring-inge.service';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
//import { CompanyInfoSii } from '../../interface/company-client.interface';
import { UpdateInvoiceOperationModalComponent } from '../../../invoice-operations/update-invoice-operation-modal/update-invoice-operation-modal.component';
import { environment } from 'src/environments/enviroments';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationsService } from 'src/app/services/notifications.service';
import { SendNotification } from 'src/app/layouts/full/interface/headers.interface';
import { ConfigRutService } from 'src/app/services/config-rut.service';

@Component({
  selector: 'app-minutes',
  templateUrl: './minutes.component.html',
  styleUrls: ['./minutes.component.scss'],
})
export class MinutesComponent implements OnInit, OnDestroy {
  @ViewChild('pdfElement') pdfEl!: ElementRef;
  public iconAproved: IconDefinition = faCheckCircle;
  public iconReject: IconDefinition = faCircleXmark;
  public minuteRequestId: number = 0;
  public minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | null = null;
  public minuteOwnersRequest: OwnersMinuteRequest[] | undefined;
  public minuteDebtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>;
  public rutUrl: number;
  public resolutionName: string;
  public showButtons: boolean = true;
  public showbtnCompletar: boolean = false;
  public hasDicomPermission: boolean;
  public pathUrlDicom: string = 'url';
  public legacyDataUser: LegacyScoring | null = null;
  public myAngularxQrCode: string = null;
  public isCompany: boolean;
  public operations: any;
  /**
   * Propiedad para contener los KPIs generados de la minuta
   */
  public minuteRequestKpi: MinuteRequestKpiDTO;
  /**
   * Propiedad de los datos del cliente de la minuta
   */
  public minuteRequestClient!: ClientMinuteRequestDTO;
  /**
   * Propiedad de los datos de la operacion de factoring que crea la minuta
   */
  public originalFactoringOperation: InvoiceOperationMinuteDTO;
  public minuteSnapshot: MinuteRequestSnapshotDTO;
  public minuteDebtors: CompanyDebtorMinuteRequestResolutionDTO[];
  public loadingMinute: boolean = false;
  public formFilter!: FormGroup;
  public icons = { faFolderClosed, faPen, faBullhorn };
  constructor(
    private realTimeMinute: RealTimeMinuteService,
    private route: ActivatedRoute,
    private minuteRequestService: MinuteRequestService,
    private toastrService: ToastrService,
    private dialog: MatDialog,

    private authService: AuthService,
    private _location: Location,
    private fb: FormBuilder,
    private router: Router,
    private tgrService: TgrServiceService,
    private filter: FilterMinuteService,
    private scoringIngeService: ScoringIngeService,
    private serviceInfoClient: ServiceInfoClientService,
    private notification: NotificationsService,
    private changeRut: ConfigRutService
  ) {
    this.formFilter = this.fb.group({
      search: [''],
    });

    this.minuteDebtorResolutions =
      new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteDebtors = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.minuteRequestKpi = {
      debtorsLast12Months: [],
      debtorsTop10: [],
      debtorsLast24Months: [],
      factoringByCesionarios: [],
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      const id = params['id'] | 0;
      this.myAngularxQrCode =
        environment.urlRoot + '/dashboards/minuteQR?id=' + id;
      this.minuteRequestId = id;
      this.getRealTimeInfoMinuteRequest(id);
      this.tgrService.getTgr;
      this.hasDicomPermission = this.authService.ValidateUserPermission(
        'RequestOwnerPermissions'
      );
     this.ocultarbtn()
      // this.getMinuteRequestKpi(id);
    });

    Swal.fire({
      title: 'Cargando Datos',
      timer: 5000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.loadingMinute = true;
        this.ocultarbtn();
      },
    });
    this.accessButton();
    this.ocultarbtn();
  }

  goBack() {
    this._location.back();
  }

  public getRealTimeInfoMinuteRequest(minuteRequestId: number) {
    this.realTimeMinute.startConnection(minuteRequestId);
    this.realTimeMinute.receivedMinuteDetai$.subscribe({
      next: (response) => {
        if (response) this.setMinuteRequestData(response);
        this.hideButton(response?.resolutions);
      },
      error: (err) => (this.loadingMinute = false),
    });

    this.realTimeMinute.receivedMinuteDebtorResolutions$.subscribe({
      next: (debtorResolutions) => {
        this.minuteDebtors = debtorResolutions;
        this.minuteDebtorResolutions = debtorResolutions;
      },
    });
  }

  resetFilter() {
    this.realTimeMinute.receivedMinuteDebtorResolutions$.subscribe({
      next: (debtorResolutions) => {
        this.minuteDebtors = debtorResolutions;
        this.minuteDebtorResolutions = debtorResolutions;
      },
    });
  }

  filtro: FilterMinutes;
  //Filtro por deudor
  filterDebtors(debtor: any) {
    const name = debtor.target.value;
    const filterMinute = this.filter.filterDealsOpportunities(
      this.minuteDebtorResolutions,
      name
    );
    this.minuteDebtors = filterMinute;
  }

  public accessButton() {
    const permissionsUsers = this.authService
      .getUserPermissions()
      .filter((e) => {
        return e.includes('UpdateClient');
      });
    if (permissionsUsers.length > 0) {
      this.showButtons = true;
    } else {
      this.showButtons = false;
    }
  }

  public ocultarbtn() {
    if (this.minuteRequestRealTime?.finalResolutionName == 'Eliminada') {
      this.showbtnCompletar = false;
      console.log(this.showbtnCompletar);
    }
  }

  public hideButton(userResolution: MinuteRequestResolutionDTO[]) {
    const user = this.authService.getNameIdentifier();
    userResolution?.filter((response) => {
      const filtro = response.userName.includes(user);
      if (
        this.minuteRequestRealTime.finalResolutionName == 'Pendiente' &&
        filtro == false
      ) {
        this.showButtons = true;
      } else {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Aprobado') {
        this.showButtons = false;
      }
      if (this.minuteRequestRealTime.finalResolutionName == 'Rechazado') {
        this.showButtons = false;
      }
    });
  }

  public setMinuteRequestData(realTimeMinute: MinuteRequestDetailRealTimeDTO) {
    if (!realTimeMinute) {
      console.error('realTimeMinute is null or undefined');
      return;
    }
    this.resolutionName = realTimeMinute.finalResolutionName;
    this.minuteRequestRealTime = realTimeMinute;
    this.operations = realTimeMinute.operations || [];
    if (realTimeMinute.snapshot) {
      const { minuteRequestKpi, client, originalOperation } = realTimeMinute.snapshot;
      this.minuteSnapshot = realTimeMinute.snapshot;
      this.setKpis(minuteRequestKpi);
      this.setMinuteClient(client);
      this.setMinuteFactoringOperation(originalOperation);
    } else {
      console.error('Snapshot is null or undefined');
      this.minuteSnapshot = null;
    }
    this.loadingMinute = false;
  
    if (this.minuteRequestClient && this.minuteRequestClient.fullRut) {
      this.isCompany = Number.parseInt(this.minuteRequestClient.fullRut.split('-')[0].replace(/\./g, '')) > 50000000;
    } else {
      this.isCompany = false;
      console.error('minuteRequestClient or fullRut is null or undefined');
    }
  }
  

  private getSnapshot(minuteRequestId: number) {
    this.minuteRequestService
      .getMinuteSnapshot(minuteRequestId)
      .pipe(finalize(() => (this.loadingMinute = false)))
      .subscribe({
        next: (response: MinuteRequestSnapshotDTO) => {
          this.minuteSnapshot = response;
          this.setKpis(response.minuteRequestKpi);
          this.setMinuteClient(response.client);
          this.setMinuteFactoringOperation(response.originalOperation);
        },
      });
  }

  ngOnDestroy(): void {
    this.realTimeMinute.stopConnection();
  }

  public redirectToMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/pdf'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  private setKpis(minuteKpi: MinuteRequestKpiDTO) {
    this.minuteRequestKpi = minuteKpi;
  }

  private setMinuteClient(minuteClient: ClientMinuteRequestDTO) {
    this.minuteRequestClient = minuteClient;
    this.minuteOwnersRequest = minuteClient.owners;
    this.serializeBase64(this.minuteRequestClient?.fullRut);
    //this.getInfoSii(this.minuteRequestClient?.fullRut);
    this.obtenerLegacyData(this.minuteRequestClient?.fullRut);
  }

  private setMinuteFactoringOperation(
    originalFactoringOperation: InvoiceOperationMinuteDTO
  ) {
    this.originalFactoringOperation = originalFactoringOperation;
  }

  updateMinutes() {
    Swal.fire({
      text: 'Se estan actualizando los datos',
      icon: 'info',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestService
          .updateMinuteSnapshot(this.minuteRequestId)
          .pipe(finalize(() => (this.loadingMinute = false)))
          .subscribe({
            next: (response: MinuteRequestSnapshotDTO) => {
              Swal.fire({
                title: 'Minuta actualizada',
                text: 'Se ha actualizado exitosamente los datos de la minuta',
                icon: 'success',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar',
              });
            },
            error: (err) => {
              console.log('Error', err);
              Swal.fire({
                title: 'Error',
                text: 'No fue posible actualizar la minuta',
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: 'Cerrar',
              });
            },
          });
      },
    });
  }
  
  alertNotification(action: string) {
    let rut;
    rut = this.changeRut.transformStringRut(this.minuteRequestClient.fullRut);
    const id = parseInt(this.authService.getRutUser());
    const request: SendNotification = {
      action,
      companyId: rut,
      date: new Date(),
      userId: id,
      type: 1
    };
    this.notification
      .createNotifications(request)
      .subscribe((a) => console.log(a));
  }

  closeMinuteConfirmation() {
    Swal.fire({
      title: 'Completar minuta',
      text: '¿Estás seguro que desea Completar esta minuta? Una vez completada, ya no será posible modificarla',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.closeMinuteRequest(this.minuteRequestId);
        this.accessButton();
        this.alertNotification('Minuta Completada');
      }
    });
  }

  public getDicomPartners() {
    if (!this.hasDicomPermission) {
      Swal.fire({
        title: 'Error',
        text: 'No posee los permisos necesarios para solicitar DICOM',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
      });
      return;
    }
    if (this.minuteOwnersRequest != undefined) {
      var partners = this.minuteOwnersRequest?.length ?? 0;
      var partnersCompleted = 0;
      for (let i = 0; i < partners; i++) {
        this.scoringIngeService
          .getDeudaDicom(
            this.minuteOwnersRequest[i].fullRut
              .replace('.', '')
              .replace('.', '')
          )
          .subscribe({
            next: (response) => {
              if (this.minuteOwnersRequest != undefined)
                this.minuteOwnersRequest[i].dicom = response.deuda;
              partnersCompleted = partnersCompleted + 1;
              if (partnersCompleted == partners) this.updateMinutes();
            },
            error(error) {
              console.log('Error:', error);
            },
          });
      }
    }
  }

  private closeMinuteRequest(minuteRequestId: number): void {
    this.minuteRequestService.closeMinuteRequest(minuteRequestId).subscribe({
      next: (response) => {
        this.toastrService.success(response.message);
      },
      error: (err) => {
        this.toastrService.error(err.error.message);
      },
    });
  }

  public formularioFacturaFormula() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.rutUrl;

    const dialogRef = this.dialog.open(
      FormularioFacturaFormulaComponent,
      dialogConfig
    );
  }

  public mostrarInforTgr() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.minuteRequestClient.fullRut;

    const dialogRef = this.dialog.open(DetalleTgrComponent, dialogConfig);
  }

  public mostrarInfoIngeSAGR() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.minuteRequestClient.legacyData;

    const dialogRef = this.dialog.open(DetalleIngeAdmComponent, dialogConfig);
  }

  public mostrarInforCmf() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.minuteRequestClient.fullRut;

    const dialogRef = this.dialog.open(DetalleCmfComponent, dialogConfig);
  }

  public mostrarActualizarDescripcion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.minuteRequestId;

    const dialogRef = this.dialog.open(
      ModificarDescripcionComponent,
      dialogConfig
    );
  }

  public displayInfoFogape() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.minuteRequestClient.fullRut;
    const dialogRef = this.dialog.open(DetalleFogapeComponent, dialogConfig);
  }

  public openMinuteRequestLine(lineType: number) {
    const request: ChangeMinuteRequestLineDTO = {
      minuteRequestId: this.minuteRequestId,
      requestedLine:
        lineType === 0
          ? this.minuteRequestRealTime.factoringLine
          : this.minuteRequestRealTime.warrantyLine,
      lineType: lineType,
    };

    const dialogRef = this.dialog.open(ChangeMinuteRequestLineModalComponent, {
      data: request,
      minWidth: '250px',
      width: '30vw',
      maxWidth: '30vw',
      maxHeight: '50vh',
    });
    dialogRef
      .afterClosed()
      .pipe(
        filter((request) => request),
        switchMap((request) =>
          this.minuteRequestService.updateMinuteRequestLine(request)
        )
      )
      .subscribe({
        next: (response) => {},
        error: (err) => {
          this.toastrService.error(err.error.resultMessage);
        },
      });
  }

  private getMinuteRequestKpi(minuteRequestId: number) {
    this.minuteRequestService.getMinuteRequestKpi(minuteRequestId).subscribe({
      next: (response) => {
        this.minuteRequestKpi = response;
      },
    });
  }

  options = {
    margin: 20,
    filename: 'minuta.pdf',
    image: {
      type: 'jpeg',
      quality: '0.90',
    },
    pagebreak: {},
    html2canvas: {
      scale: 2,
      windowWidth: window.innerWidth, // Ancho total de la ventana
      windowHeight: window.innerHeight,
    },
    jsPDF: {
      unit: 'pt',
      format: 'letter',
      orientation: 'portrait',
    },
  };

  public obtenerLegacyData(r: string) {
    const rut = r.replaceAll('.', '');
    this.minuteRequestService.getLegacyData(rut).subscribe({
      next: (response) => {
        this.legacyDataUser = response;
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }

  public transformDayToMonth(days: number): number {
    return Math.floor(days / 30);
  }

  approveMinute(id: number) {
    Swal.fire({
      icon: 'question',
      titleText: '¿Deseas Aprobar esta Minuta?',
      text: 'Ingresa algún comentario (Opcional)',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Completar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
    }).then((results) => {
      if (results.isConfirmed) {
        this.minuteRequestService.approveMinute(id, results.value).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'success',
              titleText: ' Minuta aprobada con exito',
              text: response.message,
            });
            this.getRealTimeInfoMinuteRequest(id);
            //this.alertNotification('Minuta Aprobada');
          },
          error: (error: HttpErrorResponse) => {
            Swal.fire({
              icon: 'error',
              titleText: ' Minuta no se pudo aprobar',
              text: error.error.message,
            });
          },
        });
      }
    });
  }

  rejectMinute(id: number) {
    Swal.fire({
      icon: 'question',
      titleText: '¿Rechaza la Minuta?',
      text: 'Indica por que se rechaza la minuta',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Rechazar',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
    }).then((results) => {
      if (results.isConfirmed) {
        this.minuteRequestService.rejectMinute(id, results.value).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'info',
              titleText: ' Minuta rechazada con exito',
              text: response.message,
            });

            this.alertNotification('Minuta Rechazada');
          },
          error: (error) => {
            Swal.fire({
              icon: 'error',
              titleText: ' Minuta no se pudo Rechazar',
              text: error.message,
            });
          },
        });
      }
    });
  }

  deleteMinute(idMinuta: any, estado: any) {
    if (estado == 'Aprobado') {
      Swal.fire({
        icon: 'question',
        titleText: 'Anular la Minuta?',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cerrar',
        confirmButtonText: 'Anular Minuta',
      }).then((results) => {
        if (results.isConfirmed) {
          this.minuteRequestService.deleteMinute(idMinuta).subscribe({
            next: (response) => {
              Swal.fire({
                icon: 'info',
                titleText: 'Minuta Anulada exitosamente',
              });
              this.alertNotification('Minuta Anulada');
            },
            error: (error) => {
              Swal.fire({
                icon: 'error',
                titleText: 'Minuta no se pudo Anular',
                text: error.message,
              });
            },
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'question',
        titleText: '¿Eliminar la Minuta?',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Eliminar',
      }).then((results) => {
        if (results.isConfirmed) {
          this.minuteRequestService.deleteMinute(idMinuta).subscribe({
            next: (response) => {
              this.ocultarbtn();
              Swal.fire({
                icon: 'info',
                titleText: ' Minuta eliminada con exito',
              });
           
              this.alertNotification('Minuta Eliminada');
            },
            error: (error) => {
              Swal.fire({
                icon: 'error',
                titleText: ' Minuta no se pudo Eliminar',
                text: error.message,
              });
            },
          });
        }
      });
    }
  }

  serializeBase64(rut: string) {
    this.pathUrlDicom = this.getReportUrl(rut);
  }

  getReportUrl(rut: string) {
    var rutformat = rut.split('.').join('');
    var parametros =
      '{"Token":"IngeInternalApiKey55","Rut":"' + rutformat + '"}';
    var base64Datos = window.btoa(parametros);
    return (
      'https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/' +
      base64Datos
    );
  }

  /*getInfoSii(rut: string) {
    this.serviceInfoClient.getInfoSiiCompany(rut).subscribe({
      next: (e) => {
        this.infoSii = e;
      },
      error: () => {},
      complete: () => {},
    });
  }*/

  updateInvoiceOperation(operation: FactoringOperationDTO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '80vw';
    dialogConfig.height = '85vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = operation.invoiceOperationId;
    this.dialog.open(UpdateInvoiceOperationModalComponent, dialogConfig);
  }

  canApproveAllDebtors(): boolean {
    const canApproveAll =
      this.minuteDebtors.filter((d) => d.resolutionState !== 2).length > 0;
    return canApproveAll;
  }

  approveAllDebtors(): void {
    // Obtener los deudores que no estan aprobados para su aprobacion
    const debtorsToApproveIds = this.minuteDebtors
      .filter((p) => p.resolutionState !== 2)
      .map((p) => p.companyId);
    const request: ApproveCompaniesDebtorsRequestDTO = {
      minuteRequestId: this.minuteRequestId,
      companiesIds: debtorsToApproveIds,
    };
    this.minuteRequestService.approveCompaniesDebtorsMinute(request).subscribe({
      next: (res) => {
        this.toastrService.success(res.resultMessage);
      },
      error: (err) => {
        this.toastrService.error(err.error?.message || 'Ha ocurrido un error');
      },
    });
  }

}